import { render, staticRenderFns } from "./UserMiniCard.vue?vue&type=template&id=14989603&scoped=true&"
import script from "./UserMiniCard.vue?vue&type=script&lang=js&"
export * from "./UserMiniCard.vue?vue&type=script&lang=js&"
import style0 from "./UserMiniCard.vue?vue&type=style&index=0&id=14989603&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14989603",
  null
  
)

export default component.exports